import { statusMeta } from "./formatters";

const OVERALL_ITEMS = [
  { key: "running", label: "Running", tone: "running" },
  { key: "paused", label: "Paused", tone: "paused" },
  { key: "autoPaused", label: "Inactive", tone: "auto" },
  { key: "notTracking", label: "Not tracking", tone: "muted" },
];

function liveMeta(status) {
  if (!status) return { label: "Not tracking", tone: "muted" };
  return statusMeta(status);
}

export default function TrackerStates({ counts, status, individual }) {
  if (individual) {
    const meta = liveMeta(status);
    return (
      <section className="pa-states pa-states--single" aria-label="Current tracker state">
        <p className="pa-coverage__label">Current tracker state</p>
        <p className="pa-states__single">
          <span className={`pa-badge pa-badge--${meta.tone}`}>{meta.label}</span>
          <span className="pa-states__hint">{status ? "Live session" : "No live session"}</span>
        </p>
      </section>
    );
  }

  return (
    <section className="pa-states" aria-label="Current tracker states">
      <p className="pa-coverage__label">Current tracker states</p>
      <p className="pa-coverage__copy">Among users signed in now</p>
      <div className="pa-states__grid">
        {OVERALL_ITEMS.map((item) => (
          <p key={item.key} className={`pa-state-chip pa-state-chip--${item.tone}`}>
            <span className="pa-state-chip__label">
              <i className="pa-state-chip__dot" aria-hidden="true" />
              {item.label}
            </span>
            <strong>{counts?.[item.key] || 0}</strong>
          </p>
        ))}
      </div>
    </section>
  );
}
